module.exports = __webpack_public_path__ + "static/media/02A.9d0a1869.png";